import './corkys/style';
import FormStructure from './corkys/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/client_forms/includes.js